import Navbar from "./NavBar"
import Footer from "./Footer"
import { Link } from "react-router-dom"
import serviceHeaderImageOne from "../../Images/ench-two.png"
import serviceHeaderImageTwo from "../../Images/ench-one.png"
import serviceHeaderImageThree from "../../Images/ench-three.png"
import SeoMeta from "../../Component/Seo"

const EstablishmentComplianceService = () => {

    const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Establishment Compliance Services",
    "provider": {
      "@type": "Organization",
      "name": "GRC@Pulse",
      "url": "https://grcpulse.in"
    },
    "areaServed": {
      "@type": "Country",
      "name": "India"
    },
    "description": "Avoid fines and legal issues with our expert-backed establishment compliance services. Get full support, reporting, and tracking."
  };

  return (
    <>
      <SeoMeta
        title="100% Establishment Compliance Guaranteed | Expert Legal Support"
        description="Avoid fines and legal issues with our expert-backed establishment compliance services. Get full support, reporting, and tracking."
        url="https://grcpulse.in/services/establishment-compliance"
        image="https://grcpulse.in/images/ench-one.png"
        type="service"
        canonical="https://grcpulse.in/services/establishment-compliance"
        siteName="GRC@Pulse"
        schemaJSONLD={schema}
      />
      <Navbar />
      <div className="p-3 bg-primary-color h-[500px] md:h-[400px] lg:h-[400px] bg-opacity-20 grid grid-cols-1 lg:grid-cols-2">
        <div className="w-full flex flex-col justify-center">
          <h1 className="text-3xl mb-2 mt-10 text-primary-color text-center font-bold">
            Establishment Compliance
          </h1>
          <p className="leading-6 text-center">
            Ensure that your Establishment is compliant with labor laws, statutory registrations, licenses, and regulatory obligations essential for your business to operate legally and compliantly using GRC@Pulse, your trusted partner for ensuring seamless and efficient Compliance Assurance.
          </p>
          <div className="mt-4 flex justify-center">
            <Link to="/contact-us">
              <button className="p-2 bg-primary-color text-white rounded-md shadow-lg hover:bg-danger transition duration-300">
                Contact Us
              </button>
            </Link>
          </div>
        </div>

        <div className="hidden lg:flex justify-center items-center">
          <img src={serviceHeaderImageOne} alt="GRC@Pulse service Compliance" className="w-[400px] h-[400px]" />
        </div>
      </div>
      <div className=" lg:p-[100px] md:p-[100px] xl:p-[0px] grid grid-row-1 sm:grid-cols-2 justify-center items-center">
        <div className="flex justify-center">
          <img src={serviceHeaderImageTwo} alt="GRC@Pulse Compliance service" className="w-[350px] h-[350px]" />
        </div>
        <div className="px-2">
          <h1 className="font-bold text-primary-color text-xl">Benefits of Establishment Compliance  </h1>
          <div className="flex gap-2 mt-2 items-center">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <div>
              <h1 className="font-bold">Avoidance of Legal Penalties:</h1>
              <h1> Non-compliance can result in heavy fines, legal actions, or even business shutdowns.</h1>
            </div>
          </div>
          <div className="flex gap-2 mt-4 items-center">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <div>
              <h1 className="font-bold"> Improved Employee Trust:</h1>
              <h1> Compliance fosters a positive work environment and strengthens.</h1>
            </div>
          </div>
          <div className="flex gap-2 mt-4 items-center">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <div>
              <h1 className="font-bold"> Operational Efficiency: </h1>
              <h1>
              Streamlined compliance processes reduce administrative burden and operational risks and seamless scalability.
              </h1>
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-row-1 md:grid-cols-2 lg:grid-col-2  px-4 mt-4">
        <div  className="">
          <h1 className="font-bold text-primary-color text-xl">Key Areas of Establishment Compliance  </h1>
          <div className="flex gap-2 mt-2 items-center ">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <div>
              <h1 className="font-bold"> Non-compliance can result in heavy fines, legal actions, or even business shutdowns.</h1>
            </div>
          </div>
          <div className="flex gap-2 mt-2 items-center ">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <div>
              <h1 className="font-bold"> Employee State Insurance (ESI) Compliance </h1>
            </div>
          </div>
          <div className="flex gap-2 mt-2 items-center ">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <div>
              <h1 className="font-bold">Payment of Wages Act, 1936</h1>
            </div>
          </div>
          <div className="flex gap-2 mt-2 items-center ">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <div>
              <h1 className="font-bold">Minimum Wages Act, 1948</h1>
            </div>
          </div>
          <div className="flex gap-2 mt-2 items-center ">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <div>
              <h1 className="font-bold">Payment of Gratuity Act, 1972 </h1>
            </div>
          </div>
          <div className="flex gap-2 mt-2 items-center ">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <div>
              <h1 className="font-bold">Shops and Establishments Act</h1>
            </div>
          </div>
          <div className="flex gap-2 mt-2 items-center ">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <div>
              <h1 className="font-bold">Equal Remuneration Act, 1976</h1>
            </div>
          </div>
          <div className="flex gap-2 mt-2 items-center ">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <div>
              <h1 className="font-bold">Maternity Benefit Act, 1961 </h1>
            </div>
          </div>
          <div className="flex gap-2 mt-2 items-center ">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <div>
              <h1 className="font-bold">Payment of Bonus Act, 1965</h1>
            </div>
          </div>
          <div className="flex gap-2 mt-2 items-center ">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <div>
              <h1 className="font-bold">Occupational Safety, Health, and Working Conditions Code (OSH Code)</h1>
            </div>
          </div>
          <div className="flex gap-2 mt-2 items-center ">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <div>
              <h1 className="font-bold">
                Industrial Disputes Act, 1947
              </h1>
            </div>
          </div>
          <div className="flex gap-2 mt-2 items-center">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <div>
              <h1 className="font-bold">
                Labour Welfare Fund (LWF)
              </h1>
            </div>
          </div>
        </div>
        <div className="flex justify-end">
          <img src={serviceHeaderImageThree} alt="GRC@Pulse service" className="w-[450px] h-[450px]" />
        </div>
      </div>
      <Footer />
    </>
  )
}

export default EstablishmentComplianceService